export const normalize = s => s.toLowerCase().replace(/[^a-z0-9]/g, "-");
